let successQuestion = new Event('growtypeQuizShowSuccessQuestion');

export function showSuccessQuestionEvent() {
    return successQuestion;
}
